function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadioOn = function SvgRadioOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 26.3,
    cy: 24,
    r: 9,
    style: {
      fill: "none",
      stroke: "#bbb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.3,
    cy: 24,
    r: 4.7,
    style: {
      fill: "#00cc67"
    }
  }));
};
export default SvgRadioOn;